const ja_JP = {
    homepage_title: 'QRコードでCalendarTaskモバイル版をダウンロード',
    homepage_slogn: 'CalendarTaskモバイル版',
    homepage_ios_download: 'AppStore審査中...',
    homepage_download: '今すぐダウンロード',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'QRコードでCalendarTaskモバイル版をダウンロード',
    phonedownload_slogan: 'PC・タブレットと同期、いつでもメモ',
    phonedownload_send_vip: 'アプリをインストールしてVIP会員をプレゼント',
    phonedownload_screenshot: 'スクリーンショット',
    phodedownload_macos: 'CalendarTask macOS版',
    phodedownload_windows: 'CalendarTask Windows版',
    phodedownload_otherbutton: '今すぐ見る',
    phodedownload_about: 'お問い合わせ',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: '広告なし',
    feature_easy: '月表示、シンプルで使いやすい',
    feature_reminder: 'カスタムリマインダー',
    feature_countdown: 'カウントダウン記念日',

    vip_task_succ: '受け取り成功。モバイル版でVIPを有効化',
    vip_task_error: '受け取り失敗',

    group_slogn: 'CalendarTaskチーム版招待',

    tt_title: 'CalendarTask',
    tt_share_1: '共有されました',
    tt_share_2: '時間割',
    tt_share_show_1: '「CalendarTask」アプリでQRコードをスキャンすると、PCとスマホに',
    tt_share_show_2: 'の時間割が表示されます',
    tt_share_scan_1: '「CalendarTask」アプリで',
    tt_share_scan_2: 'スキャン',
    tt_share_succ: '同期成功',

    v2_copyright: 'お問い合わせ service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. All rights reserved.',
    v2_download_appstore: 'App Storeでダウンロード',
    v2_download_googleplay: 'Google Playで入手',

    v2_main_title: 'CalendarTask モバイル',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'モバイル',
    v2_main_description: 'App Store・Google Playで<span class="name">CalendarTask</span>を検索してダウンロード',
    v2_download_ios: 'iOSをダウンロード',
    v2_download_android: 'Androidをダウンロード',
    v2_download_harmonyos: 'HarmonyOSをダウンロード',
    v2_sync_status: '同期完了！1件アップロード、0件ダウンロード',
    v2_feature_title: 'マルチデバイスデータ同期',
    v2_feature_description: 'スマホ・タブレット・PCで同期'
};
export default ja_JP;
